module.exports = __webpack_public_path__ + "static/img/hua7.ad48a62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hua7.png
// module id = ULv5
// module chunks = 22